// code-display — default skin module
// Token disposition: pass-through (no overrides)
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
  }

  .tabs-wrapper {
    margin-bottom: 0;
  }

  .tabs-wrapper[hidden] {
    display: none;
  }

  .code-wrapper {
    position: relative;
  }

  pre {
    margin: 0;
    padding: var(--run-code-padding, var(--run-space-semantic-md));
    background: var(--run-code-background, var(--run-color-surface-raised));
    color: var(--run-code-text, var(--run-color-text-primary));
    font-family: var(--run-code-font-family, ui-monospace, 'SFMono-Regular', Menlo, monospace);
    font-size: var(--run-code-font-size, var(--run-font-size-sm));
    line-height: var(--run-code-line-height, 1.6);
    border-radius: var(--run-code-radius, var(--run-radius-semantic-card));
    overflow-x: auto;
    white-space: pre;
    word-break: normal;
  }

  code {
    font-family: inherit;
    font-size: inherit;
  }

  .token.keyword    { color: var(--run-code-keyword, var(--run-color-syntax-keyword, #c678dd)); }
  .token.string     { color: var(--run-code-string, var(--run-color-syntax-string, #98c379)); }
  .token.number     { color: var(--run-code-number, var(--run-color-syntax-number, #d19a66)); }
  .token.comment    { color: var(--run-code-comment, var(--run-color-syntax-comment, #5c6370)); }
  .token.function   { color: var(--run-code-function, var(--run-color-syntax-function, #61afef)); }
  .token.tag        { color: var(--run-code-tag, var(--run-color-syntax-tag, #e06c75)); }
  .token.attr-name  { color: var(--run-code-attr-name, var(--run-color-syntax-attr-name, #e06c75)); }
  .token.attr-value { color: var(--run-code-attr-value, var(--run-color-syntax-attr-value, #98c379)); }

  .line-numbers-rows > span.highlighted {
    background: var(--run-code-highlight-line-bg, var(--run-color-surface-subtle));
    display: block;
  }

  .line-numbers .line-numbers-rows {
    color: var(--run-code-line-number-color, var(--run-color-text-tertiary));
  }

  run-icon-button[part="copy-button"] {
    position: absolute;
    top: var(--run-code-copy-button-offset, var(--run-space-semantic-sm));
    right: var(--run-code-copy-button-offset, var(--run-space-semantic-sm));
  }
`;

export function render(host) {
  const {
    isMultiFramework,
    resolvedFrameworkOrder,
    resolvedFrameworkTabs,
    activeFramework,
    resolvedLanguage,
    showLineNumbers,
    activeCode,
    isCopying,
  } = host;

  const lang = resolvedLanguage || 'html';
  const preClass = `language-${lang}${showLineNumbers ? ' line-numbers' : ''}`;
  const codeClass = `language-${lang}`;
  const copyLabel = isCopying ? 'Copied' : 'Copy code';
  const copyIcon = isCopying ? 'check' : 'copy';

  // run-tabs uses the panel attribute on run-tab to identify each tab by name.
  // active="" on run-tabs sets the initially-active panel.
  const tabsHtml = isMultiFramework
    ? `<run-tabs aria-label="Framework" active="${activeFramework}">${
        resolvedFrameworkTabs.map(t =>
          `<run-tab panel="${t.key}"${t.active ? ' active' : ''}>${t.label}</run-tab>`
        ).join('')
      }</run-tabs>`
    : '';

  host.shadowRoot.innerHTML = `
    <run-box class="outer">
      <div class="tabs-wrapper"${isMultiFramework ? '' : ' hidden'}>
        ${tabsHtml}
      </div>
      <div class="code-wrapper">
        <pre class="${preClass}"><code class="${codeClass}">${host.safeHTML(activeCode)}</code></pre>
        <run-icon-button
          part="copy-button"
          label="${copyLabel}"
          icon="${copyIcon}"
        ></run-icon-button>
      </div>
    </run-box>
  `;
}
